import { Injectable } from '@angular/core';
import { createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TranslatableEffect } from '../../i18n/TranslatableEffects';
import { ClientService } from '../../services/clients.service';
import { ClientTypesActions } from './clientTypes.actions';

@Injectable()
export class ClientTypeEffects extends TranslatableEffect {
  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientTypesActions.loadAllClientTypes),
      switchMap(() =>
        this.clientService.getClientTypes().pipe(
          // eslint-disable-next-line max-nested-callbacks
          switchMap((types) => this.selectedTranslation$.pipe(map((translation) => ({ types, translation })))),
          map(({ types, translation }) =>
            /* eslint-disable-next-line max-nested-callbacks*/
            types.map((type) => ({ ...type, description: translation[type.name] })),
          ),
          map((types) => ClientTypesActions.loadClientTypesSucceeded({ types })),
          catchError((error: unknown) => of(ClientTypesActions.loadClientTypesFailed({ error }))),
        ),
      ),
    ),
  );

  constructor(private clientService: ClientService) {
    super('clientTypesEffect');
  }
}
